import { Component, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { AbstractWidgetComponent, AppServerAPI, ComponentSelectionStorageService, ContextChange, TranslationService, WidgetStyle } from '@sdbn/common';
import { ReportSelection } from '../selection';
import { StructureNode } from '../structure-node';
import { SumRow, TimeFrameMatching } from '../sum-row';


const SELECTION = 'timeframe-matching.selection';


@Component({
    selector: 'app-timeframe-matching',
    templateUrl: './timeframe-matching.component.html',
    styleUrls: ['./timeframe-matching.component.scss'],
    standalone: false
})
export class TimeframeMatchingComponent extends AbstractWidgetComponent implements OnInit {

  isLoading = false;

  selectedCarrier: string;

  sumRow: SumRow;

  structureNodes = new Array<StructureNode>();

  sumRows = new Array<SumRow>();
  dataSource: MatTableDataSource<SumRow> = new MatTableDataSource(this.sumRows);
  columnsToDisplayForOverview = ['carrier', 'total-transports', 'with-timeslot-booking', 'early', 'in-time', 'delayed', 'late', 'not-arrived', 'not-yet-arrived', 'other'];
  columnsToDisplayForCarrier = ['date', 'total-transports', 'with-timeslot-booking', 'early', 'in-time', 'delayed', 'late', 'not-arrived', 'not-yet-arrived', 'other'];
  columnsToDisplay;

  defaultNode = null;
  strcutureSelectionFormGroup = new FormGroup({});

  constructor(
    public translationService: TranslationService,
    private appServerAPI: AppServerAPI,
    private componentSelectionStorageService: ComponentSelectionStorageService
  ) {

    super();

    this.columnsToDisplay = this.columnsToDisplayForOverview;

    this.defaultNode = new StructureNode({ stationGroupId: null, stationSetId: null, name: translationService.translate('tmc-yard.ui.timeframe-usage.structure-node.option.all') });

    this.strcutureSelectionFormGroup.addControl('structureNode', new FormControl(null, []));
    this.strcutureSelectionFormGroup.addControl('dateFrom', new FormControl(new Date(), [Validators.required]));
    this.strcutureSelectionFormGroup.addControl('dateUntil', new FormControl(new Date(), [Validators.required])),

      this.strcutureSelectionFormGroup.valueChanges.subscribe(value => {
        if (this.strcutureSelectionFormGroup.dirty) {
          this.storeSelection();
          // this.updateList();
        }
      });

    this.appServerAPI.execute<StructureNode[]>('/client/control/timeframe-usage/structure-nodes', {}).subscribe(
      nodes => {

        this.structureNodes = new Array<StructureNode>();
        this.structureNodes.push(this.defaultNode);

        for (const node of nodes) {
          this.structureNodes.push(new StructureNode(node));
        }

        const selection = componentSelectionStorageService.get(SELECTION);
        let restoredSelection = this.defaultNode;
        const dateFrom = selection?.dateFrom || new Date();
        const dateUntil = selection?.dateUntil || new Date();

        if (selection != null && selection.structureNode) {
          for (const sn of this.structureNodes) {
            if (sn.stationGroupId === selection.structureNode.stationGroupId
              || sn.stationGroupId === selection.structureNode.stationGroupId) {
              restoredSelection = sn;
              break;
            }
          }
        }

        this.strcutureSelectionFormGroup.reset(
          {
            structureNode: restoredSelection,
            dateFrom,
            dateUntil
          }
        );

        this.selectedCarrier = selection?.carrier;
      }, error => {
        console.log(error);
      }
    );

  }

  ngOnInit() {
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  private updateList() {
    if (this.isLoading) {
      return true;
    }
    this.isLoading = true;

    const selection = new ReportSelection({
      dateFrom: this.strcutureSelectionFormGroup.controls.dateFrom.value,
      dateUntil: this.strcutureSelectionFormGroup.controls.dateUntil.value,
      stationGroupId: this.strcutureSelectionFormGroup.controls.structureNode.value.stationGroupId,
      stationSetId: this.strcutureSelectionFormGroup.controls.structureNode.value.stationSetId,
      carrier: this.selectedCarrier
    });
    this.dataSource.data = [];

    this.appServerAPI.execute<any>(`/client/control/reporting/timeframe-matching`, selection)
      .subscribe(
        response => {

          const matching = new TimeFrameMatching(response);
          this.sumRows.splice(0, this.sumRows.length);
          for (const p of matching.sumRows) {
            this.sumRows.push(p);
          }
          this.dataSource.data = this.sumRows;
          this.sumRow = matching.total;

          if (this.selectedCarrier != null) {
            this.columnsToDisplay = this.columnsToDisplayForCarrier;
          } else {
            this.columnsToDisplay = this.columnsToDisplayForOverview;
          }
          this.isLoading = false;
        }, error => {
          this.isLoading = false;
        }
      );
  }

  public setSelectedCarrier(carrier: string) {
    this.selectedCarrier = carrier;
    this.storeSelection();
    this.updateList();
  }

  public resetCarrierSelection() {
    this.selectedCarrier = null;
    this.storeSelection();
    this.updateList();
  }

  public updateData() {
    this.storeSelection();
    this.updateList();
  }

  
  public isCreateDisabled(): boolean {
    return this.strcutureSelectionFormGroup.controls.dateFrom.value == null || this.strcutureSelectionFormGroup.controls.dateUntil.value == null;
  }
  
    createExcel() {
      if (this.isLoading) {
        return true;
      }
      this.isLoading = true;
      // Trigger opening a new tab. Must be as close as possible to a user action event.
      const newWindow = window.open('', 'timeframe-matching-export');
  
      // keep focus in current window
      window.focus();
  
      const selection = new ReportSelection({
        dateFrom: this.strcutureSelectionFormGroup.controls.dateFrom.value,
        dateUntil: this.strcutureSelectionFormGroup.controls.dateUntil.value,
        stationGroupId: this.strcutureSelectionFormGroup.controls.structureNode.value.stationGroupId,
        stationSetId: this.strcutureSelectionFormGroup.controls.structureNode.value.stationSetId,
        carrier: this.selectedCarrier
      });
  
      this.appServerAPI.postWithArraybufferResponse<any>(`/client/control/reporting/timeframe-matching-export`, selection).subscribe(result => {
  
        const file = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const fileURL = URL.createObjectURL(file);
  
        // we can open the file in a new tab
        if (newWindow !== null) {
          newWindow.location.href = fileURL;
        } else { // Fallback, if initial opener does not work. But popup blockers will block this.
          window.open(fileURL);
        }
        this.isLoading = false;
      }, error => {
        console.error(error);
        this.isLoading = false;
      });
    }

  private storeSelection() {
    this.componentSelectionStorageService.save(
      SELECTION, {
      structureNode: this.strcutureSelectionFormGroup.controls.structureNode.value,
      dateFrom: this.strcutureSelectionFormGroup.controls.dateFrom.value,
      dateUntil: this.strcutureSelectionFormGroup.controls.dateUntil.value,
      carrier: this.selectedCarrier
    }
    );
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
